import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import type { MouseEvent } from 'react'
import toast from 'react-hot-toast'
import type { Game } from '@/redux/reducers/gameReducer'
import LottoBannerCard from '@/ui-components/components/BetLotto/LottoBannerCard'
import { getLottoNameAndCountryFromLottoGame } from '@/utils/lotto-type-v2'
import { getBackgroundFlagGroup } from '@/utils/flag-utils'
import { getGameWithRoundTitle } from '@/utils/gameUtils'

interface LottoCardProps {
  game: Game
  round?: Game['rounds'][0]
}

// This card have behavior like card in src/page/game/LottoPage.tsx
// - can show resulted, show waiting for results and round countdown
// - but it can't show round closed or round doesn't exists
const LottoCard: React.FC<LottoCardProps> = ({ game, round }) => {
  const { t, i18n } = useTranslation()

  const { country, name: flagBackgroundName } =
    getLottoNameAndCountryFromLottoGame(game.type, game.flag)
  const title = getGameWithRoundTitle(i18n, game, round)

  const linkTo = round?.id
    ? `/lotto/${game.code}/${game.id}/${round.id}`
    : `/lotto/${game.code}/${game.id}`

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (round?.id) {
      return
    }

    event.preventDefault()
    toast.error(t('message.no_round'))
  }

  return (
    <Link to={linkTo} onClick={handleClick} className="block w-full">
      <LottoBannerCard
        country={country}
        flagBackgroundName={getBackgroundFlagGroup(flagBackgroundName)}
        title={title}
        timeRemaining={round?.close_at ?? ''}
        roundNumber={round?.round_number}
        isCancelled={round?.status === 'cancelled'}
      />
    </Link>
  )
}

export default LottoCard
